// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type NextScheduledCampaignActionQueryVariables = PrivateSchemaTypes.Exact<{
  campaignId: PrivateSchemaTypes.Scalars['PositiveInt'];
  actionId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type NextScheduledCampaignActionQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id'>
      & { scheduledAction?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'ScheduledCampaignActionModel' }
        & Pick<PrivateSchemaTypes.ScheduledCampaignActionModel, 'id' | 'campaign_email_action_id' | 'campaign_banner_id' | 'campaign_topic_share_action_id' | 'campaign_pathway_share_action_id' | 'campaign_message_action_id' | 'campaign_survey_share_action_id' | 'campaign_certification_share_action_id' | 'isBannerStarted'>
        & { emailAction?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignEmailActionModel' }
          & Pick<PrivateSchemaTypes.CampaignEmailActionModel, 'id' | 'subject' | 'send_at_day' | 'send_at_time'>
        )>, topicShareAction?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignTopicShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignTopicShareActionModel, 'id' | 'send_at_day' | 'send_at_time'>
          & { actionTopics: Array<(
            { __typename?: 'CampaignActionTopicModel' }
            & Pick<PrivateSchemaTypes.CampaignActionTopicModel, 'id'>
            & { topic: (
              { __typename?: 'TopicModelAsEditor' }
              & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'currentTitle'>
            ) }
          )> }
        )>, pathwayShareAction?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignPathwayShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModel, 'id' | 'send_at_day' | 'send_at_time'>
          & { actionPathways: Array<(
            { __typename?: 'CampaignActionPathwayModel' }
            & Pick<PrivateSchemaTypes.CampaignActionPathwayModel, 'id'>
            & { pathway: (
              { __typename?: 'PathwayModelAsAdmin' }
              & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title'>
            ) }
          )> }
        )>, banner?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignBannerModel' }
          & Pick<PrivateSchemaTypes.CampaignBannerModel, 'id' | 'header' | 'text' | 'show_at_day' | 'hide_at_day'>
        )>, surveyShareAction?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignSurveyShareActionModel' }
          & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModel, 'id' | 'send_at_day' | 'send_at_time'>
          & { actionSurveys: Array<(
            { __typename?: 'CampaignActionSurveyModel' }
            & Pick<PrivateSchemaTypes.CampaignActionSurveyModel, 'id'>
            & { survey: (
              { __typename?: 'SurveyModel' }
              & Pick<PrivateSchemaTypes.SurveyModel, 'id' | 'title'>
            ) }
          )> }
        )>, messageAction?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignMessageActionModel' }
          & Pick<PrivateSchemaTypes.CampaignMessageActionModel, 'id' | 'send_at_day' | 'send_at_time' | 'text'>
        )> }
      )> }
    )> }
  )> }
);


export const NextScheduledCampaignActionDocument = gql`
    query NextScheduledCampaignAction($campaignId: PositiveInt!, $actionId: PositiveInt!) {
  admin {
    campaign(id: $campaignId) {
      id
      scheduledAction(id: $actionId) {
        id
        campaign_email_action_id
        campaign_banner_id
        campaign_topic_share_action_id
        campaign_pathway_share_action_id
        campaign_message_action_id
        campaign_survey_share_action_id
        campaign_certification_share_action_id
        isBannerStarted
        emailAction {
          id
          subject
          send_at_day
          send_at_time
        }
        topicShareAction {
          id
          send_at_day
          send_at_time
          actionTopics {
            id
            topic {
              id
              currentTitle
            }
          }
        }
        pathwayShareAction {
          id
          send_at_day
          send_at_time
          actionPathways {
            id
            pathway {
              id
              title
            }
          }
        }
        banner {
          id
          header
          text
          show_at_day
          hide_at_day
        }
        surveyShareAction {
          id
          send_at_day
          send_at_time
          actionSurveys {
            id
            survey {
              id
              title
            }
          }
        }
        messageAction {
          id
          send_at_day
          send_at_time
          text
        }
      }
    }
  }
}
    `;

/**
 * __useNextScheduledCampaignActionQuery__
 *
 * To run a query within a React component, call `useNextScheduledCampaignActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextScheduledCampaignActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextScheduledCampaignActionQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useNextScheduledCampaignActionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NextScheduledCampaignActionQuery, NextScheduledCampaignActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NextScheduledCampaignActionQuery, NextScheduledCampaignActionQueryVariables>(NextScheduledCampaignActionDocument, options);
      }
export function useNextScheduledCampaignActionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextScheduledCampaignActionQuery, NextScheduledCampaignActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NextScheduledCampaignActionQuery, NextScheduledCampaignActionQueryVariables>(NextScheduledCampaignActionDocument, options);
        }
export type NextScheduledCampaignActionQueryHookResult = ReturnType<typeof useNextScheduledCampaignActionQuery>;
export type NextScheduledCampaignActionLazyQueryHookResult = ReturnType<typeof useNextScheduledCampaignActionLazyQuery>;
export type NextScheduledCampaignActionQueryResult = Apollo.QueryResult<NextScheduledCampaignActionQuery, NextScheduledCampaignActionQueryVariables>;